/**
 * Italian error copy — autenticazione Phase 5 (IMPL-P5-004).
 *
 * Server error codes (returned by `/api/auth/custom/*` routes) are mapped to
 * Italian human-readable strings. The default branch returns a neutral
 * fallback so we never leak server detail to the user.
 *
 * NOTE on anti-enumeration: invalid credentials, missing accounts and
 * unverified accounts all collapse to the same neutral message at the API
 * boundary (`Email o password non corretti`) — see Phase 4 login route.
 * The web layer therefore does not need to distinguish them.
 */

export function serverErrorToItalian(code: string | undefined): string {
  switch (code) {
    case 'INVALID_CREDENTIALS':
      return 'Email o password non corretti';
    case 'EMAIL_ALREADY_REGISTERED':
      return 'Questa email risulta già registrata';
    case 'INVALID_TOKEN':
      return 'Il link non è valido. Richiedi un nuovo link.';
    case 'TOKEN_EXPIRED':
      return 'Il link è scaduto. Richiedi un nuovo link.';
    case 'EMAIL_NOT_VERIFIED':
      return "L'email non è ancora stata verificata. Controlla la tua casella.";
    case 'TOO_MANY_REQUESTS':
      return 'Troppi tentativi. Riprova tra alcuni minuti.';
    case 'ACCOUNT_LOCKED':
      return 'Account temporaneamente bloccato. Riprova tra alcuni minuti o reimposta la password.';
    case 'INVALID_CONSENT':
      return 'Devi accettare i Termini di Servizio e la Privacy Policy.';
    default:
      return 'Si è verificato un errore. Riprova fra qualche istante.';
  }
}

/**
 * 429 from any auth route signals rate-limit / lockout. The login route also
 * uses 429 when the LoginLockoutService blocks a sign-in after the threshold,
 * so the web layer can show specific lockout copy (vs. generic 401 which is
 * intentionally neutral).
 */
export function isLockedOut(status: number, _code?: string): boolean {
  return status === 429;
}
